import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthService } from '../auth.service';
import { GenericService } from '../generic.service';
import { environment } from '../../environments/environment';
import { result } from 'underscore';
import { NotificationService } from '../notification.service';
import { OrderPipe } from 'ngx-order-pipe';




@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class HomeComponent implements OnInit {

  public totalDossiers : number;
  public totalConsultants : number;
  public totalCandidats : number;
  public totalCandiNonValid : number;
  public seeMoreThanOnce : number;
  public seeOnlyOne: number;

  //afficher par défaut le prénom du Manager connecté dans la liste déroulante
  public defaultManager : string;

  //Récupération des dossiers mis en favorite
//id de l'utilisateur pour l'ajout du dossier en favorite
  public idUser : any;
  public sortKey :string;
  public MyFavorite : any[] = [];
  public AllFavorite: any[] = [];
  public dataFavorite = {
    idManager: "",
    idDossier: "",
    manager: ""
  }

//variable pour ranger les dossiers mis en favoris dans l'ordre décroissant de la date de dernier entretien
public order: string = "dateDernierEntretien";
public reverse: boolean = true;


  constructor(private _authService : AuthService, private _genericService : GenericService, private _notifyService: NotificationService, 
    private orderPipe: OrderPipe) { }

  ngOnInit() {
    this._authService.checkCredentials();
    this.idUser = this._authService.getAuthenticatedIdUser();
    this.defaultManager = this._authService.getAuthenticatedFirstName();
    this.getTotalDossiers();
    this.getTotalConsultants();
    this.getTotalCandidats();
    this.getAllCandiNonValid();
    this.getAllAppliSeeMoreThanOne();
    this.getAllAppliSeeThanOne();
    this.getAllMyFolderFavorite();
    this.getAllFolderFavorite()
  }



//Ranger les élements du tableau des favorites das l'ordre décroissant de la date du dernier entretien
setOrder(value: string) {
  if (this.order === value) {
    this.reverse = !this.reverse;
  }
  this.order = value;
}



//Récupérer tous les dossiers d'un Manager ou Admin mis en favorite
  getAllMyFolderFavorite(){
    this.dataFavorite.idManager = this._authService.getAuthenticatedIdUser();
    this.dataFavorite.manager = this.defaultManager;
    this._genericService.searchConsultantWithBody(environment.statsgetAllMyFolderFavorite, this.dataFavorite, true, -1, this.sortKey)
    .subscribe(
      result => { 
        for (let i = 0; i < result.length; i++) {
          this.MyFavorite.push({ 
            prenom: result[i].general.prenom, 
            nom: result[i].general.nom, 
            profil: result[i].general.profil, 
            dateDernierEntretien: result[i].general.dateDernierEntretien,  
            idDoc: result[i]._id, 
          });
        }
      },
      error => {
      }
    );

  }


//Récupérer tous les dossiers mis en favorite
getAllFolderFavorite(){
  this.dataFavorite.idManager = this._authService.getAuthenticatedIdUser();
  this._genericService.getResource(environment.statsgetAllFolderFavorite, true, 0)
  .subscribe(
    result => { 
      for (let i = 0; i < result.length; i++) {
        this.AllFavorite.push({ 
          prenom: result[i].general.prenom, 
          nom: result[i].general.nom, 
          profil: result[i].general.profil, 
          dateDernierEntretien: result[i].general.dateDernierEntretien,  
          idDoc: result[i]._id,
          favoris: result[i].favorites 
        });
      }
    },
    error => {
    }
  );

}



  // Récupère le nombre total de dossiers de la BD
  getTotalDossiers(){
    this._genericService.getResource(environment.statsTotalDossier, true ,0)
    .subscribe(
      result => { 
        this.totalDossiers = result.data;
      },
      error => {
      }
    );
  }



  //Récuprérer le nombre total de collaborateur encore actif
  getTotalConsultants(){
    this._genericService.getResource(environment.statsTotalConsultants, true ,0)
    .subscribe(
      result => { 
        this.totalConsultants = result.data;
      },
      error => {
      }
    );
  }



  //Récupérer le nombre total de candidat
  getTotalCandidats(){
    this._genericService.getResource(environment.statsTotalCandidats, true ,0)
    .subscribe(
      result => { 
        this.totalCandidats = result.data;
      },
      error => {
      }
    );
  }


    
  // Récupérer le nombre total de candidatures non validées
  getAllCandiNonValid(){
    this._genericService.getResource(environment.statsTotalCandiNonValid, true ,0)
    .subscribe(
      result => { 
        this.totalCandiNonValid = result.data;
      },
      error => {
      }
    );
  }



  // Nombre total de candidatures vues plus d'une fois
  getAllAppliSeeMoreThanOne(){
    this._genericService.getResource(environment.statsgetTotalseenMoreThanOnce, true ,0)
    .subscribe(
      result => {
        this.seeMoreThanOnce = result.data
      },
      error => {
      }
    );
  }


  // Nombre de candidatures vues une seule fois
  getAllAppliSeeThanOne(){
    return  this.totalDossiers  - this.seeMoreThanOnce
   }


   //retirer un dossier en favorite
  removeFavoriteAction(id: any){
    if (confirm("Voulez vous Vraiment supprimer ce dossier de vos favoris ?")) {
      this.dataFavorite.idDossier = id;
      this.dataFavorite.idManager = this._authService.getAuthenticatedIdUser();
      this.dataFavorite.manager = this.defaultManager;
      this._genericService.saveResource(environment.removeDossierFavorite, this.dataFavorite, true, environment.contentTypes.json)
      .subscribe(
        () => {
          this._notifyService.showSuccess("Dossier retiré des favoris", "Remove favorite", 2000)
          this.reloadPage()

        },
        () => {
          this._notifyService.showError("Erreur lors de la suppression du dossier en favoris", "Remove favorite", 3000)

        }
      );
    }
  }



  //Recharger la page
  reloadPage(){
    setTimeout(()=>{
      window.location.reload();
    }, 3000);
  } 


}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts